<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<section class="compare-area white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{ 'FOOTER.BLOG_TITLE' | translate }}</h3>
                    <p class="text">{{ 'FOOTER.BLOG_TEXT' | translate }}</p>
                </div>
                <div class="blog-content">
                    <!-- Blog Categories -->
                    <div class="blog-filters">
                        <button class="filter-btn" [class.active]="!selectedCategory" (click)="filterItems(null)">
                            {{ 'FOOTER.BLOG_ALL' | translate }}
                        </button>
                        <button *ngFor="let category of categories" class="filter-btn"
                            [class.active]="selectedCategory === category.name" (click)="filterItems(category.name)">
                            {{ category.displayName || category.name }}
                        </button>
                    </div>

                    <!-- Blog Items Grid -->
                    <div class="blog-grid">
                        <article class="blog-card" *ngFor="let blogItem of getCurrentPageItems()">
                            <div class="blog-card-image">
                                <a (click)="navigateToBlogPost(blogItem.id)">
                                    <img [src]="blogItem.imageURL || '../assets/img/blog-img/3.png'" alt="article" />
                                </a>
                                <div class="category">{{ blogItem.blogCategory?.name || 'Fără categorie' }}</div>
                            </div>
                            <div class="blog-card-content">
                                <div class="meta">
                                    <span class="date">{{ blogItem.publishedDate | date: 'MMM d, y' }} |
                                        <i class="lni lni-comments-alt"></i> {{ blogItem.commentsCount || 0 }}
                                        Comment{{ blogItem.commentsCount === 1 ? '' : 's' }}
                                    </span>
                                    <span class="author">{{ blogItem.user?.firstName }} {{ blogItem.user?.lastName
                                        }}</span>
                                </div>
                                <h4>{{ blogItem.title }}</h4>
                                <p>{{ blogItem.summary }}</p>
                                <a (click)="navigateToBlogPost(blogItem.id)" class="read-more">
                                    {{ 'FOOTER.BLOG_READ_MORE' | translate }}
                                </a>
                            </div>
                        </article>
                    </div>

                    <!-- Pagination -->
                    <div class="blog-pagination">
                        <button class="pagination-btn" *ngFor="let page of getPageNumbers()"
                            [class.active]="currentPage === page" (click)="goToPage(page)">
                            {{ page }}
                        </button>
                        <button class="pagination-btn" *ngIf="currentPage < totalPages" (click)="nextPage()">
                            <i class="lni lni-chevron-right"></i>
                        </button>
                    </div>
                    <div class="debug-info" style="margin-top: 20px; text-align: center; color: #666;">
                        <small>
                            Total items: {{ blogItems.length }} |
                            Items per page: {{ itemsPerPage }} |
                            Current page: {{ currentPage }} |
                            Total pages: {{ totalPages }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>